<template>
  <div class="c-filterable-list--default" data-css="c-filterable-list">
    <div class="grid__container">
      <div class="grid__row">
        <form
          class="c-form--filterable-list"
          :class="isLoading()"
          data-css="c-form"
        >
          <!-- Hier Einbau Vue.js-Komponente für Eventfilter -->
          <filter-newsroom-event v-if="getDisplayEventFilter" />
          <NewsLoader />
          <filterable-list v-if="!displayShow" />
          <div v-if="displayShow">
            <slot></slot>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
import NewsLoader from "./components/Loader.vue";

export default {
  name: "NewsRoomApp",
  components: {
    NewsLoader,
  },
  async created() {
		await this.$store.dispatch('getEventTopics', { thema: this.$store.state.name});
  		await this.$store.dispatch('getNewsroomInitData', { thema: this.$store.state.thema} ); // VUEX Action dispatch function
},
  computed: {
    displayShow() {
      return this.$store.state.displayShow;
    },
    getDisplayEventFilter() {
      return this.$store.state.displayEventFilter;
    },
  },
  methods: {
    isLoading() {
      return this.$store.state.isLoading ? "is-loading" : "is-success";
    }
  },
};
</script>
